module.exports = __webpack_public_path__ + "static/emerald-a73b425dd62d5b56bb7da184a2e6b0fc.png";